import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { createLectureItem as createLectureItemApi } from "../../../../services/dashboard/apiLecture";

function useCreateLectureItem() {
    const queryClient = useQueryClient();

    const {
        mutate: createLectureItem,
        isPending: isCreating,
        error,
    } = useMutation({
        mutationFn: createLectureItemApi,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["lectureItemsDashboard"],
            });

            toast.success("تم أنشاء محتوي للمحاضره بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { createLectureItem, isCreating, error };
}

export default useCreateLectureItem;
